import { Employee } from "../api/generated";
import { useEffect, useRef, useState } from "react";

interface RegisterStepTwoProps {
  employee: Employee;
  onConfirm: (employee: Employee) => void;
}

export const EmployeeRegisterStepTwo = ({
  employee,
  onConfirm,
}: RegisterStepTwoProps) => {
  const [straps, setStraps] = useState<string[]>(employee.straps ?? []);
  const [newStrap, setNewStrap] = useState("");
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    // Focus op het invoerveld wanneer component mounted
    inputRef.current?.focus();
  }, []);

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleConfirm();
    }
  };

  const handleRemoveStrap = (index: number) => {
    setStraps((current) => current.filter((_, i) => i !== index));
  };

  const handleStrapChange = (index: number, value: string) => {
    setStraps((current) =>
      current.map((strapValue, i) => (i === index ? value : strapValue)),
    );
  };

  const handleConfirm = () => {
    const trimmed = newStrap.trim();
    const nextStraps = trimmed ? [...straps, trimmed] : straps;

    if (trimmed) {
      setStraps(nextStraps);
    }

    const updatedEmployee: Employee = {
      ...employee,
      straps: nextStraps,
    };
    onConfirm(updatedEmployee);
  };

  return (
    <div className="mt-6 w-full max-w-md mx-auto">
      {/* Employee informatie */}
      <div className="card bg-base-200 shadow-xl mb-6">
        <div className="card-body">
          <h2 className="card-title text-lg">
            {employee.firstName} {employee.lastName}
          </h2>
          <div className="divider my-2"></div>
          <div className="space-y-2 text-sm">
            <div>
              <span className="font-semibold">Geboortedatum:</span>{" "}
              {employee.birthDate}
            </div>
            {employee.coordinator && (
              <div>
                <span className="font-semibold">Coördinator:</span>{" "}
                {employee.coordinator}
              </div>
            )}
            {employee.role && (
              <div>
                <span className="font-semibold">Rol:</span> {employee.role}
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="form-control">
        {straps.length > 0 && (
          <div className="mb-4 space-y-2">
            <label className="label py-0">
              <span className="label-text">Bestaande bandjes</span>
            </label>
            {straps.map((strapValue, index) => (
              <div key={`${strapValue}-${index}`} className="join w-full">
                <input
                  type="text"
                  value={strapValue}
                  onChange={(e) => handleStrapChange(index, e.target.value)}
                  className="input input-bordered join-item w-full"
                />
                <button
                  type="button"
                  onClick={() => handleRemoveStrap(index)}
                  className="btn btn-error join-item"
                >
                  Verwijderen
                </button>
              </div>
            ))}
          </div>
        )}

        <label className="label">
          <span className="label-text">Bandje toevoegen</span>
        </label>
        <input
          ref={inputRef}
          type="text"
          placeholder="Voer bandjenummer in"
          value={newStrap}
          onChange={(e) => setNewStrap(e.target.value)}
          onKeyPress={handleKeyPress}
          className="input input-bordered w-full"
        />

        <label className="label">
          <span className="label-text-alt">
            Druk Enter om het bandje toe te voegen
          </span>
        </label>
      </div>

      <div className="mt-6">
        <button onClick={handleConfirm} className="btn btn-primary w-full">
          Bevestigen en doorgaan
        </button>
      </div>
    </div>
  );
};
